import { createRoot } from "react-dom/client";
import { HashRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";
import "lib-flexible";
import "@/assets/styles/reset.scss";
import "antd-mobile/es/global";
import "@/assets/styles/index.scss";
import { MetaMaskProvider } from "@onyx-p/metamask-react";
import { ConfigProvider } from "antd-mobile";
import enUS from "antd-mobile/es/locales/en-US";
import "./locales/index";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<Router>
				<ConfigProvider locale={enUS}>
					<MetaMaskProvider>
						<App />
					</MetaMaskProvider>
				</ConfigProvider>
			</Router>
		</PersistGate>
	</Provider>
);

reportWebVitals();
